export const color = {
	primary: '#332d2f',
	secondary: '#ffffff',
	tertiary: '#ffffff',
	headerLogo: '#332d2f',

	blackOne: '#000',
	blackTwo: '#43484D',

	buttonNextBgColor: '#332d2f',
	buttonNextTextColor: '#ffffff',
	buttonNextMobileColor: '#332d2f',
	buttonNextMobileTextColor: '#000',
	buttonNextBorderColor: '#332d2f',
	buttonNextMobileBorderColor: '#332d2f',
	buttonNextHoverBgColor: '#ffffff',
	buttonNextHoverTextColor: '#332d2f',
	buttonNextHoverBorderColor: '#332d2f',

	buttonBackBgColor: '#ffffff',
	buttonBackTextColor: '#332d2f',
	buttonBackMobileBgColor: '#332d2f',
	buttonBackMobileTextColor: '#000',
	buttonBackBorderColor: '#332d2f',
	buttonBackMobileBorderColor: '#332d2f',
	buttonBackHoverBgColor: '#332d2f',
	buttonBackHoverTextColor: '#fff',
	buttonBackHoverBorderColor: '#332d2f',

	exchangeSelectBtnTextColor: '#ffffff',
	exchangeSelectBtnBgColor: '#f1c71d',
	exchangeSelectBtnBorderColor: '#f1c71d',
	exchangeSelectBtnBorderSize: '2px',
	exchangeSelectBtnSVGColor: '#ffffff',

	exchangeDontSelectBtnTextColor: '#ffffff',
	exchangeDontSelectBtnBgColor: '#000000',
	exchangeDontSelectBtnBorderColor: '#000000',
	exchangeDontSelectBtnBorderSize: '2px',
	exchangeDontSelectBtnSVGColor: '#ffffff',

	exchangeRemoveSelectBtnTextColor: '#f1c71d',
	exchangeRemoveSelectBtnBgColor: '#000000',
	exchangeRemoveSelectBtnBorderColor: '#000000',
	exchangeRemoveSelectBtnBorderSize: '2px',
	exchangeRemoveSelectBtnSVGColor: '#ffffff',

	flowButtonSelectedTextColor: '#000000',
	flowButtonSelectedBgColor: '#f1c71d',
	flowButtonSelectedBorderColor: '#f1c71d',

	flowButtonOriginalTextColor: '#000000',
	flowButtonOriginalBgColor: '#ffffff',
	flowButtonOriginalBorderColor: '#000000',

	grayOne: '#E6E6E6',
	grayTwo: '#f7f7f7',
	grayThree: '#666',
	grayFour: '#C4C4C4',
	grayFive: '#DCDCDC',
	graySix: '#A6A6A6',
	graySeven: '#F1F1F1',
	grayEight: '#F5F5F5',
	grayTen: '#666666',
	grayEleven: '#EDEDED',
	grayTwelve: '#E6E6E6',
	grayThirteen: '#DADADA',
	grayFourteen: '#696969',
	grayFifteen: '#E5E5E5',
	graySixteen: '#E2E2E2',
	graySeventeen: '#D3D3D3',
	grayEighteen: '#5E5E5E',
	grayNineteen: '#A1A1A1',

	greenTwo: '#D7F2EA',
	greenThree: '#D7F2EA',
	greenFour: 'rgba(45,205,178,0.2)',

	redOne: '#EA0000',
	redTwo: '#F32727',
}
